export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/initiate-stock-transfer`,
        name: `${prefix}.initiate-stock-transfer.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.initiate-stock-transfer.create`,
                PageDescription: "Inventory management: Initiate stock transfer",
            },
        },
    },
];
